<template>
    <div id="kpInfo">
        <MyTitle theTitle="申请开票信息"/>
        <div class="fd-com-scroll" v-if="isShow">
            <template v-for="(item,index) in list">
                <Slogan :theTitle="item.title"/>

                <van-cell-group>
                    <template v-for="(item1,index1) in item.dataList">

                        <van-field
                            v-model="item1.value"
                            readonly
                            :label="item1.name"
                            @click="toastJointCcxx(item1.value)"
                        ></van-field>

                    </template>


                </van-cell-group>
            </template>

        </div>
    </div>
</template>

<script>
// 引用 —— 元素组件
import MyTitle from '../../../components/common/myTitle'
import Slogan from '../../../components/common/slogan';
import {Toast} from "vant";

// 引用 —— 前提数据
import {list3} from './dataInit'

// 引用 —— 调用接口
import {getCode,getCxkp} from "./../../../api/common";

// 引用 —— 工具函数
import {extend} from '../../../utils/common.js';


export default {
    name: "kpInfo",
    components: {
        MyTitle,Slogan
    },
    data(){
        return {
            //前提数据
            list:extend([],list3),
            nTtlxCode:{'1':'codeList_105000','2':'codeList_109000'},

            //接口数据 isShow判断
            codeList_902001:[],// 发票类型
            codeList_902003:[],// 抬头类型
            codeList_105000:[],// 证件(照)类型-证件 个人
            codeList_109000:[],// 证件(照)类型-证照 企业
            data:{},//开票信息总数据

            //组装数据
            nTtlx:'',//抬头类型
        }
    },
    computed:{
        //是否显示
        isShow(){
            if(this.codeList_902001.length>0&&
                this.codeList_902003.length>0&&
                this.codeList_105000.length>0&&
                this.codeList_109000.length>0&&
                Object.keys(this.data).length>0
            ){
                this.initData();
                return true;
            }else{
                return false;
            }
        },
    },
    methods: {
        //返回
        goHistory(path) {
            this.$router.push(path)
        },
        toastJointCcxx(value){
            Toast(value);
        },
        //字典翻译
        translate(key,val){
            switch (key) {
                case 'nFplx':
                    var data_nFplx=this.codeList_902001.filter(item=>item.code===val)[0];
                    return data_nFplx?(data_nFplx.name||'--'):'--';
                case 'nTtlx':
                    var data_nTtlx=this.codeList_902003.filter(item=>item.code===val)[0]
                    return data_nTtlx?(data_nTtlx.name||'--'):'--';
                case 'nZzlx':
                    var data_nZzlx=this[this.nTtlxCode[this.nTtlx]].filter(item=>item.code===val)[0];
                    return data_nZzlx?(data_nZzlx.name||'--'):'--';
                default:
                    return val||'--';
            }
        },
        //初始化数据
        initData(){
            const data=this.data;
            data&&this.list.map(item=>{
                item.dataList.map(item1 => {
                    item1.value = this.translate(item1.key, data.hasOwnProperty(item1.key) ? String(data[item1.key]) : '');
                });
            });
        },

        //获取数据
        getData(){
            this.dbid=sessionStorage.getItem('dbid');
            // 发票类型
            getCode({codetype: 902001}).then((res) => {this['codeList_902001'] = res.data;});
            // 抬头类型
            getCode({codetype: 902003}).then((res) => {this['codeList_902003'] = res.data;});
            // 证件(照)类型-证件 个人
            getCode({codetype: 105000}).then((res) => {this['codeList_105000'] = res.data;});
            // 证件(照)类型-证照 企业
            getCode({codetype: 109000}).then((res) => {this['codeList_109000'] = res.data;});
            // 开票信息
            getCxkp({dbid:this.dbid}).then((res) => {
                this.data={...res.data.jsxx,...res.data.kpxx};
                this.nTtlx=this.data.nTtlx;
            });
        }
    },
    created(){
        this.getData();
    }

}
</script>
